import { createContext, useContext } from 'react';
import { RootStore } from './app.store';

export const StoreContext = createContext<RootStore>({} as RootStore);
export const StoreProvider = StoreContext.Provider;

export const useAppStore = () => useContext(StoreContext);
